import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Modal from '../components/Modal';
import toast from 'react-hot-toast';
import { Plus, Edit2, Trash2 } from 'lucide-react';
import { formatCurrency } from '../utils/helpers';

const empty = { account_code:'', account_name:'', account_type:'asset', parent_id:'', opening_balance:0, status:1 };

export default function Accounts() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = () => api.get('/accounts').then(r => setList(r.data.data || []));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.account_name || !form.account_code) return toast.error('Code and Name required');
    try {
      if (editId) await api.put('/accounts/' + editId, form);
      else await api.post('/accounts', form);
      toast.success('Saved'); setOpen(false); setForm(empty); setEditId(null); load();
    } catch (e) { toast.error(e?.response?.data?.message || 'Error'); }
  };
  const del = async (id) => { if (!window.confirm('Delete?')) return; try { await api.delete('/accounts/' + id); toast.success('Deleted'); load(); } catch (e) { toast.error('Error'); } };
  const edit = (a) => { setForm({...empty, ...a}); setEditId(a.id); setOpen(true); };

  const types = {asset:'badge-green', liability:'badge-red', equity:'badge-purple', income:'badge-blue', expense:'badge-orange'};

  return (
    <div className="card">
      <div className="card-header">
        <h3>Chart of Accounts ({list.length})</h3>
        <button className="btn btn-blue" onClick={() => { setForm(empty); setEditId(null); setOpen(true); }}><Plus size={14}/> Add Account</button>
      </div>
      <div className="table-wrap">
        <table>
          <thead><tr><th>Code</th><th>Account Name</th><th>Type</th><th className="td-num">Opening Balance</th><th className="td-num">Current Balance</th><th>Status</th><th>Actions</th></tr></thead>
          <tbody>
            {list.length ? list.map(a => (
              <tr key={a.id}>
                <td><strong>{a.account_code}</strong></td>
                <td>{a.account_name}</td>
                <td><span className={'badge ' + types[a.account_type]}>{a.account_type}</span></td>
                <td className="td-num">{formatCurrency(a.opening_balance)}</td>
                <td className="td-num">{formatCurrency(a.current_balance)}</td>
                <td><span className={'badge ' + (a.status==1?'badge-green':'badge-red')}>{a.status==1?'Active':'Inactive'}</span></td>
                <td>
                  <button className="btn btn-sm btn-gray" onClick={()=>edit(a)}><Edit2 size={12}/></button>{' '}
                  <button className="btn btn-sm btn-red" onClick={()=>del(a.id)}><Trash2 size={12}/></button>
                </td>
              </tr>
            )) : <tr><td colSpan="7" className="empty">No accounts</td></tr>}
          </tbody>
        </table>
      </div>

      <Modal open={open} onClose={()=>setOpen(false)} title={editId?'Edit Account':'Add Account'}
        footer={<>
          <button className="btn btn-gray" onClick={()=>setOpen(false)}>Cancel</button>
          <button className="btn btn-blue" onClick={save}>{editId?'Update':'Create'}</button>
        </>}>
        <div className="form-grid">
          <div className="form-group"><label>Account Code *</label><input value={form.account_code} onChange={e=>setForm({...form, account_code:e.target.value})}/></div>
          <div className="form-group"><label>Account Name *</label><input value={form.account_name} onChange={e=>setForm({...form, account_name:e.target.value})}/></div>
          <div className="form-group"><label>Type *</label>
            <select value={form.account_type} onChange={e=>setForm({...form, account_type:e.target.value})}>
              <option value="asset">Asset</option><option value="liability">Liability</option>
              <option value="equity">Equity</option><option value="income">Income</option><option value="expense">Expense</option>
            </select>
          </div>
          <div className="form-group"><label>Parent Account</label>
            <select value={form.parent_id||''} onChange={e=>setForm({...form, parent_id:e.target.value})}>
              <option value="">-- None --</option>
              {list.filter(a=>a.id!=editId).map(a=><option key={a.id} value={a.id}>{a.account_code} — {a.account_name}</option>)}
            </select>
          </div>
          <div className="form-group"><label>Opening Balance</label><input type="number" value={form.opening_balance} onChange={e=>setForm({...form, opening_balance:e.target.value})}/></div>
        </div>
      </Modal>
    </div>
  );
}
